import { DidUser } from '@/services/auth';
import { useFlag } from '@/services/featureFlags';
import { useCreditQuery } from '@/state/credits/credits';
import { PlanGroup } from '@d-id/types';

export function useFirstUserSubscriptionTimestamp() {
    const { data: credits, isFetched } = useCreditQuery({
        includeExpired: true,
    });
    const paidCreditRecords = credits?.credits?.filter(({ plan_group }) => !!plan_group);

    if (!paidCreditRecords?.length) {
        return {
            timestamp: 0,
            isFetched,
        };
    }
    return {
        timestamp: Math.min(...paidCreditRecords.map(({ valid_from }) => new Date(valid_from).getTime())) || 0,
        isFetched,
    };
}

export function useUnlimitedFirstMonthCreditsEnabled(user?: DidUser | null) {
    const unlimitedFirstMonthEnabled = useFlag('unlimited_first_month_enabled', false);
    const unlimitedFirstMonthPlans = [PlanGroup.ADVANCED, PlanGroup.ENTERPRISE, PlanGroup.PRO, PlanGroup.LITE];
    const { timestamp: userFirstSubscriptionTimestamp, isFetched } = useFirstUserSubscriptionTimestamp();

    if (!unlimitedFirstMonthEnabled || !unlimitedFirstMonthPlans.includes(user?.planGroup as PlanGroup)) {
        return {
            enabled: false,
            isFetched,
        };
    }

    const firstSubscriptionDate = new Date(userFirstSubscriptionTimestamp);
    const firstMonthEndDate = new Date(firstSubscriptionDate.setMonth(firstSubscriptionDate.getMonth() + 1));

    return {
        enabled: new Date().getTime() < firstMonthEndDate.getTime(),
        isFetched,
    };
}
